<template>
      <v-dialog v-if='assetDetail' v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Detail : {{assetDetail.Discovery.AssetTag}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="saveAssetModel">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container grid-list-md text-xs-center>
        <v-layout row wrap>

            <v-expansion-panel>
    <v-expansion-panel-content
    >
      <template v-slot:header>
        <div>Hardware Spec</div>
      </template>
      <v-card>
    <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
            <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            v-model="assetDetail.Discovery.Brand"
            label="Brand"
          >{{assetDetail.Discovery.Brand}}</v-text-field>
            </v-flex>
      <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            v-model="assetDetail.Discovery.Model"
            label="Model"
          >{{assetDetail.Discovery.Model}}</v-text-field>
          </v-flex>
           <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            v-model="assetDetail.Discovery.Serial"

            label="Serial"
          >{{assetDetail.Discovery.Serial}}</v-text-field>
          </v-flex>
           <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            v-model="assetDetail.Discovery.Size"

            label="Size"
          >{{assetDetail.Discovery.Size}}</v-text-field>
            </v-flex>
          <v-flex d-flex xs12 sm6 md6>
           <v-text-field
            v-model="assetDetail.Discovery.Resolution"

            label="Resolution"
          >{{assetDetail.Discovery.Resolution}}</v-text-field> 
          </v-flex>

            <v-flex d-flex xs12 sm6 md6 >
            <v-select
            v-model="assetDetail.Discovery.Location"
            :items="LocationsArr"
            label="Location"
            required
            ></v-select>
            </v-flex>
        <v-flex d-flex xs12 sm6 md6>
           <v-select
            v-model="assetDetail.Discovery.formFactor"
            :items="formFactorArr"
            label="Form Factor"
          >{{assetDetail.Discovery.formFactor}}</v-select>
          </v-flex>

          <v-flex d-flex xs12 sm6 md6>
           <v-select
            v-model="assetDetail.Discovery.grade"
            :items="gradeArr"
            label="Cosmetic Condition"
          >{{assetDetail.Discovery.grade}}</v-select>
          </v-flex>
          <v-flex d-flex xs12 sm6 md6>
           <v-select
            v-model="assetDetail.Discovery.scratches"
            :items="scratchesArr"
            label="Scratches"
          >{{assetDetail.Discovery.scratches}}</v-select>
          </v-flex>
          <v-flex d-flex xs12 sm6 md6>
           <v-text-field
           type='number'
            v-model="assetDetail.Discovery.screen"

            label="Screen Size"
          >{{assetDetail.Discovery.screen}}</v-text-field> </v-flex>

                    <v-flex d-flex xs12 sm6 md6>
           <v-text-field
           
            v-model="assetDetail.Discovery.osTitle"

            label="OS"
          >{{assetDetail.Discovery.osTitle}}</v-text-field> </v-flex>

                  <v-flex d-flex xs12 sm6 md6>
           <v-text-field
           
            v-model="assetDetail.Discovery.weight"
            type="number"
            label="Weight"
          >{{assetDetail.Discovery.weight}}</v-text-field> </v-flex>
          
          </v-layout>
        </v-container>
      </v-card>
    </v-expansion-panel-content>
    <v-expansion-panel-content
    >
      <template v-slot:header>
        <div>Magento Settings</div>
      </template>
      <v-card>
        <v-container grid-list-md text-xs-center>
        <v-layout row wrap>

        <v-flex d-flex xs12 sm6 md6>
        <v-select
        v-model='magentoSetting.enable'
          :items="enableList"
          item-text="text"
          item-value="value"
          label="Status"
        ></v-select>
        </v-flex>
        <v-flex d-flex xs12 sm6 md6>
        <v-text-field
          type='number'
            v-model="magentoSetting.websiteID"
            label="Website ID"
          >{{magentoSetting.websiteID}}</v-text-field>
           </v-flex>
            <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            v-model="magentoSetting.Sku"
            label="SKU"
          >{{magentoSetting.Sku}}</v-text-field>
            </v-flex>
     <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            v-model="magentoSetting.listingTitle"
            label="Listing Title"
          >{{magentoSetting.listingTitle}}</v-text-field>
            </v-flex>
             <v-flex d-flex xs12 sm6 md6>
          <v-text-field
          type='number'
            v-model="magentoSetting.price"
            label="Price"
          >{{magentoSetting.price}}</v-text-field>
            </v-flex>
             <v-flex d-flex xs12 sm6 md6>
          <v-text-field
          type='number'
            v-model="magentoSetting.qty"
            label="qty"
          >{{magentoSetting.qty}}</v-text-field>
            </v-flex>
             <v-flex d-flex xs12 sm6 md6>
          <v-select
            v-model="magentoSetting.isInStock"
            label="in stock?"
            :items='inStockList'
            item-text="text"
          item-value="value"
          >{{magentoSetting.isInStock}}</v-select>
            </v-flex>
            <v-flex d-flex xs12 sm6 md6>
           <v-text-field
           
            v-model="magentoSetting.description"

            label="description"
          >{{magentoSetting.description}}</v-text-field> </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-expansion-panel-content>
    <v-expansion-panel-content
    >
      <template v-slot:header>
        <div>Magento filterable attribute</div>
      </template>
      <v-card>
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
             
        </v-layout>
        </v-container>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>

</v-layout>
        </v-container>
        
      </v-card>
    </v-dialog>
</template>


<script>
const fb = require("../firebaseConfig.js");
export default {
      props : {
        assetDetail: Object
    },
    data() {
      return {
        dialog : true,
        LocationsArr : [],
        formFactorArr : ["Full Tower Case","Mid Tower Computer Case","Mini Tower Computer Case","Small Form Factor Computer Case","Portable Workstations","Ultrabook","Netbook","Convertible Laptop"],
        gradeArr : ["A","B","C","D","E"],
        scratchesArr : ["Yes","No"],
         enableList : [
          {text : "Enable" ,value :  1},
          {text : "Disable",value : 0}
        ],
        inStockList : [
          {text : "In Stock" ,value :  true},
          {text : "Out of Stock",value : false}
        ],
         magentoSetting : {
          sku : "",
          listingTitle : "",
          enable : 0,
          qty : 1,
          isInStock : true,
          websiteID : 1,
          description : "",
        },
      }
    },
          watch: {
      dialog: function(val) {
      if (val === false) {
        this.$emit("computerDetailModalClose");
      }
    }
  },
  mounted(){
    
   fb.LocationsCollections.get().then(d => {
     d.forEach((doc) => {
       this.LocationsArr.push(doc.data().name)
     })
   })
   },
  
  methods : {
    saveAssetModel(){
    this.dialog = false
    
    fb.AssetsCollections.doc(this.assetDetail.Discovery.AssetTag).update(this.assetDetail)
     if(this.assetDetail.Discovery.Location !== null){
       fb.LocationsCollections.where("assets","array-contains",this.assetDetail.Discovery.AssetTag).get().then(snapshot => {
         if(snapshot.empty){
           fb.LocationsCollections.doc(this.assetDetail.Discovery.Location).get().then(snapshot2 => {
              var data = snapshot2.data().assets
                data.push(this.assetDetail.Discovery.AssetTag)
              fb.LocationsCollections.doc(this.assetDetail.Discovery.Location).update({
                assets : data
              })
           })
         }
       }) 
      }
  },
  }
}
</script>
